import styled from 'styled-components';
import { List } from '@mui/material';

export const StyledList = styled(List)`
  max-height: 450px;
  overflow-y: auto;
`;

export const TeamIcon = styled.img`
  display: inline-block;
  height: 1rem;
  width: 1rem;
  position: relative;
  top: 2px;
`;
